import { BaseApi } from './base.api.js';

export class RiskMitigationDefinitionApi extends BaseApi {
    constructor(client) {
        super(client, '/risk-mitigation-definition');
    }
}
